import React from 'react';
import {IMessageContext, MessagesContext} from "../MessagesContext";

export function withMessages<P extends { messages?: IMessageContext }>(
    WrappedComponent: React.ComponentType<P>
) {
    return function ComponentWithMessages(props: Omit<P, 'messages'>) {
        const context = React.useContext(MessagesContext);
        if (!context) {
            throw new Error('withMessages must be used within a MessagesProvider');
        }
        return <WrappedComponent {...(props as P)} messages={context} />;
    };
}